import isEmpty from "lodash/isEmpty";
import qs from "qs";

const SCHMALTZ_BASE_URL =
  process.env.SCHMALTZ_BASE_URL || process.env.NEXT_PUBLIC_SCHMALTZ_BASE_URL;
const SCHMALTZ_TOKEN =
  process.env.SCHMALTZ_TOKEN || process.env.NEXT_PUBLIC_SCHMALTZ_TOKEN;

const _getPath = (path: string, params = {}): string => {
  let pathName = `${SCHMALTZ_BASE_URL}/v1/${path}`;

  if (!isEmpty(params))
    pathName = `${pathName}?${qs.stringify(params, {
      arrayFormat: "brackets"
    })}`;

  return pathName;
};

const _getHeaders = () => ({
  Accept: "application/json",
  "Content-Type": "application/json",
  "x-api-key": SCHMALTZ_TOKEN
});

export const create = async (
  path: string,
  body: any
): Promise<{ [key: string]: any }> => {
  try {
    const res = await fetch(_getPath(path), {
      method: "post",
      headers: _getHeaders(),
      body: JSON.stringify(body)
    });

    if (!res.ok) {
      throw `POST ${res.status} ${res.url}`;
    }

    return res.json();
  } catch (err) {
    throw new Error(err);
  }
};

export const get = async (
  path: string,
  params?: any
): Promise<{ [key: string]: any }> => {
  try {
    const res = await fetch(_getPath(path, params), {
      method: "get",
      headers: _getHeaders()
    });

    if (!res.ok) {
      throw `GET ${res.status} ${res.url}`;
    }

    return res.json();
  } catch (err) {
    throw new Error(err);
  }
};
